// extracted by css-extract-rspack-plugin
export default {"cls1":"StatelessWorkCardsUpsellModal-styles-cls1__XB","cls2":"StatelessWorkCardsUpsellModal-styles-cls2_RzD StatelessWorkCardsUpsellModal-styles-cls1__XB"};